import { isEmpty, isArray } from 'lodash';

/**
 * add422ErrorsIfWeHaveIt
 * @param mainError
 * @param responseErrors
 */
export const add422ErrorsIfWeHaveIt = (mainError, responseErrors) => {
  // CREW-1256 — anything that cannot be tied to a field still has to reach the
  // user. Guarding `source?.pointer` stopped the handler CRASHING on a
  // record-level error (crew change rotation "Rotation save failed",
  // 2026-06-24) but it also dropped that error on the floor: the save was
  // refused and the screen said nothing at all.
  const recordErrors = [];

  const errorByField = responseErrors.reduce((acc, error) => {
    const { status, source, title } = error || {};
    if (status !== '422') return acc;

    if (source?.pointer) {
      const key = source.pointer.split('/')[3];
      if (key) return { ...acc, [key]: title };
    }

    // No pointer, or a pointer naming nothing we can map to a field — keep the
    // server's own sentence rather than losing it.
    if (title) recordErrors.push(title);

    return acc;
  }, {});

  if (!isEmpty(errorByField)) mainError.errorByField = errorByField;
  if (recordErrors.length) mainError.recordErrors = recordErrors;
};

export default async (response) => {
  const errorName = `${response.status} ${response.statusText}`;
  const mainError = new Error(errorName);

  let responseData;

  try {
    responseData = await response.json();
  } catch (e) {
    // CREW-1256 — `String(...)`, because Fetch exposes `response.status` as a
    // NUMBER while a JSON:API envelope states it as a string, and everything
    // downstream compares against `'422'`. Emitting the number here meant a 422
    // with an unparseable body was dropped by the very guard that exists to
    // catch a backend drifting to integers — see the contract test — and the
    // user saw nothing at all, which is the failure this whole ticket is about.
    responseData = {
      errors: [{
        status: String(response.status),
        title: response.statusText,
      }],
    };
  }

  mainError.response = response;
  mainError.apiErrors = responseData.errors;

  if (isArray(responseData.errors)) {
    add422ErrorsIfWeHaveIt(mainError, responseData.errors);
  }

  return mainError;
};
